import { Config } from '../config';

export enum MediaTypes {
  document = 'document',
  image = 'image',
  video = 'video',
  audio = 'audio',
}

export const SupportedDocumentTypes = ['.pdf'];
export const SupportedImageTypes = [
  '.apng',
  '.avif',
  '.gif',
  '.jpg',
  '.jpeg',
  '.jfif',
  '.pjpeg',
  '.pjp',
  '.png',
  '.webp',
  '.tiff',
];
export const SupportedVideoTypes = ['.avi', '.mp4', '.mpeg', '.ogv', '.ts', '.webm'];
export const SupportedAudioTypes = ['.aac', '.cda', '.mid', '.midi', '.mp3', '.oga', '.opus', '.wav', '.weba'];

export interface MediaIcons {
  [colour: string]: string;
}

export const MediaTypeIcons: { [type: string]: MediaIcons } = {
  jpg: {
    blue: `${Config.assetCdnRoot}file-type-icons/jpg_icon_blue.svg`,
    white: `${Config.assetCdnRoot}file-type-icons/jpg_icon_white.svg`,
  },
  mov: {
    blue: `${Config.assetCdnRoot}file-type-icons/mov_icon_blue.svg`,
    white: `${Config.assetCdnRoot}file-type-icons/mov_icon_white.svg`,
  },
  pdf: {
    blue: `${Config.assetCdnRoot}file-type-icons/pdf_icon_blue.svg`,
    white: `${Config.assetCdnRoot}file-type-icons/pdf_icon_white.svg`,
  },
  png: {
    blue: `${Config.assetCdnRoot}file-type-icons/png_icon_blue.svg`,
    white: `${Config.assetCdnRoot}file-type-icons/png_icon_white.svg`,
  },
};
